"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currentLocationReducerBase = void 0;
var tslib_1 = require("tslib");
var actions_1 = require("../../constants/actions");
var domConstants_1 = require("../../constants/domConstants");
var currentLocationReducerBase = function (state, action) {
    if (!action) {
        return state || null;
    }
    if (action.type === actions_1.LOCATION_CHANGE) {
        var locationChangeAction = action;
        var values = locationChangeAction.values;
        var element = document.getElementById(domConstants_1.SCROLL_CONTAINER_ID) || document.documentElement;
        return tslib_1.__assign(tslib_1.__assign({}, values), { navigateMs: new Date().getTime(), previous: {
                isRoutes: state === null || state === void 0 ? void 0 : state.isRoutes,
                navigateMs: state === null || state === void 0 ? void 0 : state.navigateMs,
                query: state === null || state === void 0 ? void 0 : state.query,
                scrollTop: element.scrollTop,
                pathname: state === null || state === void 0 ? void 0 : state.pathname,
            } });
    }
    return state || null;
};
exports.currentLocationReducerBase = currentLocationReducerBase;
